import { useScheduleStore, DAY_TYPE_TABS } from '@/modules/drivers/stores/scheduleStore'
import type { DayTypeFormType } from '@/modules/drivers/stores/scheduleStore'
export type { DayTypeFormType }
export type ScheduleContextType = ReturnType<typeof useScheduleStore.getState>

export const useSchedule = useScheduleStore

// Kept for callers that render <ScheduleProvider> — it's now a no-op wrapper.
// The setRefreshKey prop is no longer needed; callers should watch
// useScheduleStore(s => s.refreshKey) directly.
const ScheduleProvider: React.FC<{
  children: React.ReactNode
  setRefreshKey?: any
}> = ({ children }) => children as React.ReactElement

export default ScheduleProvider
export { DAY_TYPE_TABS }
